export const requestform = {
  //Title
  changeLocationRecord: 'Thay đổi địa chỉ',
  requestTicketCRM: 'PHIẾU YÊU CẦU CRM',
  serviceType: 'Loại dịch vụ',

  //RequestFilterForm
  deleteFilter: 'Xóa lọc',
  result: 'Áp dụng',
  statusRequestForm: 'Trạng thái phiếu yêu cầu',
  isSendToCmisTitle: 'Tình trạng CMIS',
  isAssignedTitle: 'Giao phiếu cho nhân viên',
  waitingConfirm: 'Chờ xác nhận',
  time: 'Thời gian',
  creatingFormTime: 'Thời gian tạo phiếu',
  fromDate: 'Từ ngày',
  toDate: 'Đến ngày',
  receptionTime: 'Thời gian tiếp nhận',
  processingTime: 'Thời gian xử lý',
  inChargeDepartment: 'Phòng đội phụ trách',
  typeOfService: 'Loại dịch vụ',
  delete: 'Xóa',
  filter: 'Bộ lọc',
  inputInformation: 'Nhập thông tin cần tìm',
  serviceTypelist: 'Dịch vụ',

  //RequestFormList
  sortBy: 'sắp xếp theo',
  sort: 'Sắp xếp',
  chooseAll: 'Chọn tất cả',
  ticket: 'phiếu',
  currentChoosenTicket: 'phiếu đang chọn',
  cancelChooseTicket: 'Hủy',
  receiveTicket: 'Tiếp nhận hồ sơ',
  outstagePowerArea: 'Mất điện khu vực',

  // Request Detail
  //Left
  createInformationTitle: 'Thông tin khởi tạo',
  dateRequest: 'Ngày yêu cầu:',
  ticketCreator: 'Người tạo:',
  appointmentDate: 'Ngày hẹn:',
  receptionDate: 'Ngày tiếp nhận:',
  recipient: 'Người tiếp nhận:',
  corporateUnit: 'Đơn vị: ',
  completedDate: 'Ngày hoàn tất:',
  completedPersion: 'Người hoàn tất',
  processByCMIS: 'Điện lực xử lý',
  completeTitle: 'THÔNG TIN HOÀN TẤT',
  notCompleteStatus: 'Chưa hoàn thành',
  acceptChannel: 'Kênh tiếp nhận:',
  createInfo: 'Thông tin khởi tạo',
  collaborationProgress: 'Quá trình phối hợp:',
  responsibleDepartment: 'Phòng đội phụ trách:',
  collaborationDepartment: 'Phòng đội phối hợp:',
  requestTicketId: 'Mã phiếu',
  customerContact: 'Khách hàng liên hệ',
  customerContractTime: 'lần',

  //Right
  requestTicket: 'Phiếu yêu cầu #',
  answerQuestion: 'Hỏi đáp',
  notMultiplleTimeRequest: 'Không phải phiếu yêu cầu nhiều lần',
  multiplleTimeRequest: 'Phiếu yêu cầu nhiều lần',
  detailStatusRequestForm: 'Trạng thái phiếu:',
  isTranferCmisTicket: 'Phiếu chuyển CMIS: ',
  typeCmisTicket: '[Loại dịch vụ CMIS]',
  isCmisTransferTrue: 'Bắt buộc chuyển Cmis',
  isCmisTransferFalse: 'Không bắt buộc chuyển Cmis',
  cmisTransferFail: 'Chưa chuyển CMIS',
  cmisTranfered: 'Đã chuyển CMIS #',
  tryAgainButton: 'Chuyển',
  requestHistory: 'Lịch sử phiếu yêu cầu',

  customerInformationTitle: 'Thông tin khách hàng',
  customerName: 'Họ tên KH',
  customerPhone: 'Điện thoại KH',
  customerAddress: 'Địa chỉ KH',
  customerCode: 'Mã khách hàng',
  customerAddressUnitCode: 'Mã địa chính',
  customerAddressUnit: 'Địa chính',
  meterSerialNumber: 'Số công tơ',
  routeCode: 'Phiên lộ trình',
  meterPointCode: 'Tên trạm',
  distributionStationCode: 'Mã trạm',
  distributionStationName: 'Tên trạm',
  customerCreateTicketHistory: 'Lịch sử yêu cầu',
  usingEvnHcmInformation: 'Đã sử dụng ứng dụng EVNHCMC',
  notUsingEvnHcmInformation: 'Chưa sử dụng ứng dụng EVNHCMC',

  customerRequestInformationTitle: 'Thông tin người yêu cầu',
  customerRequestName: 'Họ tên người Y/C',
  customerRequestPhone: 'Điện thoại người Y/C',
  numberOfCalls: 'Số lần gọi',
  customerRequestAddress: 'Địa chỉ người Y/C',
  districtAndWard: 'Phường-Quận',

  customerRequestCIN: 'Số CCCD',
  dateOfIssue: 'Ngày cấp',
  placeOfIssue: 'Nơi cấp',

  requestContentTitle: 'Nội dung yêu cầu',
  processingTitle: 'Quá trình xử lý',
  assignEmployeeTitle: 'Giao phiếu cho nhân viên',
  resolutionTitle: 'Kết quả xử lý yêu cầu',

  file: 'File đính kèm',

  historyCreatingTicket: 'Lịch sử yêu cầu',

  employee: 'Nhân viên',
  assignEmployee: 'Giao phiếu cho nhân viên',
  reasonOutage: 'Nguyên nhân mất điện:',
  timeOutage: 'Giờ mất điện:',
  datePowerRestored: 'Ngày có điện:',
  timePowerRestored: 'Giờ có điện',
  isPowerRestore: 'Khách hàng đã có điện lại',

  // Button
  exportExcel: 'Xuất excel',
  printTicket: 'In phiếu',
  transferCustomerCareCenter: 'Chuyển TTCSKH', // CCC - Customer Care Center: TTCSKH
  transferCollaboration: 'Chuyển phòng phối hợp',
  transferOtherOrganization: 'Chuyển đơn vị xử lý',
  transferProcessingRoom: 'Chuyển phòng xử lý',
  transferAppCT: 'Chuyển AppCT',

  transferCmisButton: 'Chuyển CMIS',

  completedButton: 'Hoàn tất',
  completedCollaborationButton: 'Hoàn tất phối hợp',
  acceptTicket: 'Tiếp nhận',
  inprocessTicket: 'Cập nhật quá trình xử lý',
  updateTicket: 'Cập nhật',
  otherActionTicket: 'Thao tác khác',
  obstacleTickets: 'Trở ngại',
  updateObstacleTicket: 'Cập nhật trở ngại',
  completedObstacleTicket: 'Hoàn tất trở ngại',
  callAgain: 'Khách hàng liên hệ lại',
  update: 'Cập nhật',
  numOfRequest: 'Đã liên hệ',
  numContacts: 'lần',
  confirmAssignEmployee: 'Xác nhận giao phiếu',
  chooseAllTickets: 'Chọn toàn bộ',

  // Confirm Modal
  confirmChangeCMIS: 'Xác nhận chuyển CMIS',
  confirmChangeCMISContent: 'Vui lòng xác nhận chuyển phiếu đến hệ thống CMIS với loại dịch vụ',
  confirmButton: 'Xác nhận',

  //Transfer organization unit
  chooseOrganizationUnit: 'Chọn phòng phối hợp',
  chooseProcessingRoom: 'Chọn phòng xử lý',
  processingContentTitle: 'Nội dung',

  //Transfer Center Customer Career
  confirmTransferToCustomerCenterCare: 'Chuyển phiếu yêu cầu đến TTCSKH',

  //Transfer App Công trường
  transferAppCTTitle: 'Chuyển phiếu yêu cầu đến App công trường',

  //Obstacle modal
  obstacleTicketProcessing: 'Trở ngại xử lý phiếu yêu cầu',
  obstacleContent: 'Nội dung trở ngại',
  estimatedEndDatePicker: 'dd/mm/yyyy',

  //Assign Ticket
  assignTicketTitle: 'Giao phiếu cho nhân viên',

  //Transfer Ticket To
  cancelTicket: 'Hủy',
  transferToElectricity: 'Chuyển Điện Lực',
  transferToCSKH: 'Chuyển CSKH',
  transferToKT: 'Chuyển phòng KT',
  transferToCenter: 'Chuyển trung tâm',
  completeTicket: 'Hoàn thành',

  changeTicketInformation: 'Thay đổi thông tin phiếu',

  oldLocation: 'Địa chỉ cũ',
  newLocation: 'Địa chỉ mới',
  changeTo: 'Chuyển sang',

  pendingReceptionTicketNotification: 'Phiếu chờ tiếp nhận',
  cmisProcessingProgress: 'Tiến độ xử lý CMIS',

  //Request List
  responsibleOrganizationUnit: 'P/Đội phụ trách: ',
  assigneeEmployee: 'Đã giao NV: ',
  notAssigneeEmployee: 'Chưa giao nhân viên'
};
